import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";

const getUserEmail = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
    return userInfo?.user_info?.email || null;
  } catch (error) {
    console.debug("Unable to read user email:", error?.message);
    return null;
  }
};

const extractRows = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];
  for (const key of ["data", "rows", "result", "results", "items", "records"]) {
    if (Array.isArray(payload[key])) return payload[key];
  }
  return [];
};

const extractPagination = (payload, data) => {
  if (payload?.pagination && typeof payload.pagination === "object") {
    return payload.pagination;
  }
  if (data?.pagination && typeof data.pagination === "object") {
    return data.pagination;
  }
  return {};
};

// /**
//  * Fetches Product Version (PV) insights for the RMPM dashboard.
//  * @param {Object}  params
//  * @param {Object}  params.filters     - Filter selections, defaults to {}
//  * @param {Object}  params.weekRange   - { from, to } week window
//  * @param {Object}  params.pagination  - { page, pageSize }
//  * @returns {Promise<{ rows: Array, totalRecords: number }>} PV rows and server total
//  */
export async function fetchProductVisionData({
  filters = {},
  weekRange = { from: 1, to: 19 },
  pagination = { page: 1, pageSize: 50 },
} = {}) {
  const body = {
    email: getUserEmail(),
    type: "PV Insights Page",
    filters,
    weekRange,
    pagination,
  };

  try {
    const payload = await authenticatedFetch(URL.pvData, {
      method: "POST",
      body: JSON.stringify(body),
    });
    const data = payload?.final_output ?? payload?.data ?? payload;
    const rows = extractRows(data);
    const responsePagination = extractPagination(payload, data);
    const rawTotal =
      responsePagination.total ??
      responsePagination.totalRecords ??
      responsePagination.total_records ??
      data?.total ??
      data?.totalRecords;
    const totalRecords = Number(rawTotal);
    if (rows.length === 0) {
      console.debug("PV data: no rows extracted. Raw payload:", payload);
    }
    return {
      rows,
      totalRecords: Number.isFinite(totalRecords) ? totalRecords : rows.length,
    };
  } catch (error) {
    console.error("Error fetching product vision data:", error.message);
    throw error;
  }
}